// extracted by mini-css-extract-plugin
export default {"iframe":"ForbesEntryPoint_iframe__rBPRe"};